// Dias corridos, sem depender do fuso horario ou da duracao dos meses.
export function dataPeriodo(valor: any): string | null {
  if (!valor) return null;
  const texto = typeof valor === 'string' ? valor : valor instanceof Date
    ? `${valor.getFullYear()}-${String(valor.getMonth() + 1).padStart(2, '0')}-${String(valor.getDate()).padStart(2, '0')}`
    : `${valor.year}-${String(valor.month).padStart(2, '0')}-${String(valor.day).padStart(2, '0')}`;
  if (!/^\d{4}-\d{2}-\d{2}$/.test(texto)) return null;
  const data = new Date(texto + 'T00:00:00Z');
  return Number.isFinite(data.getTime()) && data.toISOString().slice(0, 10) === texto ? texto : null;
}
export function limitePeriodo(inicio: any): string | null {
  const iso = dataPeriodo(inicio);
  if (!iso) return null;
  const data = new Date(iso + 'T00:00:00Z'); data.setUTCDate(data.getUTCDate() + 31);
  return data.toISOString().slice(0, 10);
}
export function erroPeriodoConsulta(inicio: any, fim: any, opcional = false): string {
  if (opcional && !inicio && !fim) return '';
  const a = dataPeriodo(inicio), b = dataPeriodo(fim);
  if (!a) return 'Selecione a data inicial primeiro.';
  if (!b) return 'Selecione uma data final válida.';
  if (b < a) return 'A data final deve ser igual ou posterior à data inicial.';
  if (b > limitePeriodo(a)) return 'A data final deve ser no máximo 31 dias após a data inicial.';
  return '';
}
